export type Route = { name: "home" } | { name: "callback" } | { name: "game"; guildId: string };

export function parseRoute(pathname?: string): Route {
  try {
    const path = pathname ?? window.location.pathname;
    if (path === "/callback" || path === "/callback/") return { name: "callback" };
    const m = path.match(/^\/bakery\/([^/]+)/);
    if (m?.[1]) return { name: "game", guildId: decodeURIComponent(m[1]) };
  } catch {
    return { name: "home" };
  }
  return { name: "home" };
}

export function navigate(path: string): void {
  try {
    window.history.pushState(null, "", path);
  } catch {
    return;
  }
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function gamePath(guildId: string): string {
  return "/bakery/" + encodeURIComponent(guildId);
}
